module.exports = __webpack_public_path__ + "assets/img/00009.cb83ac52.png";